import { type FC } from "react";

import { cn } from "@/shared/lib";

import type { LocaleMeta } from "../model";

interface LocaleItemProps {
  /** DDC: 단일 locale 엔티티 데이터 */
  data: LocaleMeta;
  /** 현재 활성 locale 여부 */
  isActive?: boolean;
}

/**
 * 단일 locale 시각화 (DDC Entity UI)
 *
 * @example
 * ```tsx
 * <LocaleItem data={{ code: "ko", nativeName: "한국어", shortLabel: "KO", dir: "ltr" }} isActive />
 * ```
 */
export const LocaleItem: FC<LocaleItemProps> = ({ data, isActive = false }) => (
  <span
    className={cn(
      "flex w-full items-center justify-between px-4 py-2.5 text-sm transition-colors",
      "hover:bg-brand-50/30 rounded-xl",
      isActive ? "text-brand-600 font-semibold" : "text-gray-700"
    )}
  >
    <span>{data.nativeName}</span>
    {isActive && (
      <svg
        className="text-brand-600 h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2.5}
        aria-hidden="true"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    )}
  </span>
);
